import { test } from '@wetransfer/ad-block-detection';
import { AdTechGlobal } from '@wetransfer/ad-sdk';

import { isAdBlockingLibraryEnabled, emitAdBlockInitialized } from './helpers';

// TODO: AdTechGlobal type should be defined and customized in Transfer, not in the ad-sdk
export const init = async (): Promise<void> => {
  if (!isAdBlockingLibraryEnabled()) {
    emitAdBlockInitialized();

    return;
  }

  test({ logLevel: 'error' }).then((result) => {
    window.AdTech = {
      ...(window.AdTech || {}),
      adBlockDetection: result,
    } as AdTechGlobal;

    emitAdBlockInitialized();
  });
};
